/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CertificateImportAction = {
    ImportAll: 'IMPORT_ALL',
    SkipSelfSigned: 'SKIP_SELF_SIGNED',
    MustBeSelfSigned: 'MUST_BE_SELF_SIGNED'
} as const;

export type CertificateImportAction = typeof CertificateImportAction[keyof typeof CertificateImportAction];



